module.exports = __webpack_public_path__ + "static/media/je.51e29959.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadBackgroundImg/je.jpg
// module id = 730
// module chunks = 0